define.alias("shared/components/shared/restricted-area/modal", "settings/components/shared/restricted-area/modal");